import { CreateNoteAction, FetchNotesAction, GenericPatientNoteAction, UpdatePatientTagsAction, fetchNotes, setNote, setNotes, setNotesFetching } from './actions';
import { call, put, takeEvery } from 'redux-saga/effects';

import { ApiResponse } from 'apisauce';
import { HealAPI } from '../../healApi';
import { Patient } from '../../api';
import { toast } from '../message/actions';
import { createPatientNote, deletePatientNote, fetchPatientNotes, updatePatientNote } from '../../api/patients';
import { PatientNote } from '../../api/patients.types';

function* handlePatientNoteFetchNotes(action: FetchNotesAction) {
  yield put(setNotesFetching(action.data.patientId, true));
  const result: PatientNote[] = yield call(fetchPatientNotes, action.data.patientId);
  yield put(setNotes(action.data.patientId, result));
  yield put(setNotesFetching(action.data.patientId, false));
}

function* handlePatientNoteCreate(action: CreateNoteAction) {
  const { patientId, note, visitCode, operationsOnly } = action.data;
  try {
    const result: PatientNote = yield call(createPatientNote, patientId, note, visitCode, operationsOnly);
    yield put(setNote(result));
  } catch (e: any) {
    // Error toast handled at api call
    yield put(setNotesFetching(action.data.patientId, false));
  }
}

function* handlePatientNoteUpdate(action: GenericPatientNoteAction) {
  const { patientId, id, note, visitCode, operationsOnly } = action.data.patientNote;
  try {
    const result: PatientNote = yield call(updatePatientNote, patientId, id, note, visitCode, operationsOnly);
    yield put(setNote(result));
    yield put(toast({ type: 'success', title: 'Success', content: 'The patient note has been updated.' }));
  } catch (e: any) {
    yield put(toast({ type: 'error', title: 'Error', content: e.message }));
  }
}

function* handlePatientNoteDelete(action: GenericPatientNoteAction) {
  const { patientId, id } = action.data.patientNote;
  const result: boolean = yield call(deletePatientNote, patientId, id);
  if (result) {
    yield put(toast({ type: 'success', title: 'Success', content: 'The patient note has been deleted.' }));
  } else {
    yield put(toast({ type: 'error', title: 'Error', content: 'Failed to delete the patient note.' }));
  }
}

function* handlePatientTagsUpdate(action: UpdatePatientTagsAction) {
  const { patientId, updateRequest } = action.data;
  const result: ApiResponse<Patient> = yield call(HealAPI.updatePatientTags, patientId, updateRequest);
  if (result.ok) {
    yield put(fetchNotes(patientId));
    yield put(toast({ type: 'success', title: 'Success', content: 'Patient tags have been updated.' }));
  } else {
    yield put(toast({ type: 'error', title: 'Error', content: (result.data || ({} as any)).description }));
  }
}

export function* patientNotesFlow() {
  yield takeEvery(['PATIENT_NOTES_FETCH'], handlePatientNoteFetchNotes);
  yield takeEvery(['PATIENT_NOTES_CREATE_NOTE'], handlePatientNoteCreate);
  yield takeEvery(['PATIENT_NOTES_UPDATE_NOTE'], handlePatientNoteUpdate);
  yield takeEvery(['PATIENT_NOTES_DELETE_NOTE'], handlePatientNoteDelete);
  yield takeEvery(['PATIENT_TAGS_UPDATE'], handlePatientTagsUpdate);
}
